import { useSelector } from 'react-redux';

const useTranslations = (translations) => {
  const language = useSelector(state => state.i18n.language.current);
  const i18n = translations?.[language] || {};

  return i18n;
};

export default useTranslations;